// src/components/PainelDetalhe.js
import React, { useEffect, useRef, useState } from "react";
import ChatIA from "./ChatIA";
import { Lupa } from "./Icones";

// Painel lateral sobre o mapa com a ficha de um registro e o assistente de IA.
// No celular ocupa a tela inteira. Serve para notícias e para casos.
function PainelDetalhe({ rotulo, titulo, subtitulo, tipo, id, sugestoes, aoFechar, children }) {
  const [aba, setAba] = useState("ficha");
  const painelRef = useRef(null);
  const fecharRef = useRef(null);

  useEffect(() => {
    setAba("ficha");
    painelRef.current?.querySelector(".painel-corpo")?.scrollTo(0, 0);
    fecharRef.current?.focus({ preventScroll: true });
  }, [tipo, id]);

  useEffect(() => {
    const aoTeclar = (e) => {
      if (e.key === "Escape") aoFechar();
    };
    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [aoFechar]);

  return (
    <aside className="painel" ref={painelRef} aria-label={titulo}>
      <header className="painel-topo">
        <div className="painel-topo-linha">
          <span className="painel-rotulo">{rotulo}</span>
          <button type="button" className="painel-fechar" onClick={aoFechar} ref={fecharRef} aria-label="Fechar">
            ×
          </button>
        </div>
        <h2 className="painel-titulo">{titulo}</h2>
        {subtitulo && <p className="painel-subtitulo">{subtitulo}</p>}
        <div className="painel-abas" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={aba === "ficha"}
            className={aba === "ficha" ? "ativa" : ""}
            onClick={() => setAba("ficha")}
          >
            Ficha
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={aba === "chat"}
            className={aba === "chat" ? "ativa" : ""}
            onClick={() => setAba("chat")}
          >
            Perguntar à IA
            <Lupa className="painel-aba-icone" />
          </button>
        </div>
      </header>

      <div className="painel-corpo" hidden={aba !== "ficha"}>
        {children}
        <button type="button" className="painel-chamada-ia" onClick={() => setAba("chat")}>
          <strong>Ficou alguma dúvida?</strong>
          <span>Pergunte ao assistente sobre este registro.</span>
        </button>
      </div>
      {/* O chat continua montado ao trocar de aba para não perder a conversa. */}
      <div className="painel-chat" hidden={aba !== "chat"}>
        <ChatIA tipo={tipo} id={id} sugestoes={sugestoes} />
      </div>
    </aside>
  );
}

// Bloco "rótulo: valor" da ficha; some quando não há valor.
export function Campo({ rotulo, children, largo = false }) {
  const vazio = children === null || children === undefined || children === ""
    || (Array.isArray(children) && children.length === 0);
  if (vazio) return null;
  return (
    <div className={`ficha-campo ${largo ? "ficha-campo-largo" : ""}`}>
      <dt>{rotulo}</dt>
      <dd>{Array.isArray(children) ? children.join(" · ") : children}</dd>
    </div>
  );
}

export default PainelDetalhe;
